import { normalizeSupportedLanguage, type SupportedLanguage } from '@workspace/i18n';

/**
 * Bootstrap 阶段（i18next 快照就绪前）Loading 文案的唯一事实源的镜像。
 * 与 `locales/<locale>.json` 的 `common.pageLoading.entering` 一一对应，
 * 由 `__tests__/bootstrap-loading-texts.test.ts` 的 parity 断言强制同步。
 *
 * 用途：Loading 首次渲染时 i18n 快照往往尚未 commit，
 * 用它保证门与文案同时出现、且语言与后续 t() 一致。
 */
export const BOOTSTRAP_LOADING_TEXTS: Record<SupportedLanguage, string> = {
    en: 'Entering the magic realm...',
    'zh-CN': '正在进入魔法世界...',
    'zh-TW': '正在進入魔法世界...',
    'de-DE': 'Magische Welt wird betreten...',
    'pt-BR': 'Enter entrando no reino mágico...',
    'es-ES': 'Entering el reino mágico...',
    'fr-FR': 'Entering dans le royaume magique...',
    'id-ID': 'Enterdi alam ajaib...',
    'it-IT': 'Enterentro nel regno magico...',
    'ja-JP': 'Enter魔法の領域へ...',
    'ko-KR': 'Enter마법의 영역을 탐험 중...',
    'ru-RU': 'Enterв волшебном мире...',
    'ar-SA': 'Enterالدخول إلى العالم السحري...',
    'tr-TR': 'Entersihirli alemde...',
};

/**
 * 按语言取 bootstrap Loading 文案；归一化与 @workspace/i18n 同一链路，
 * 不支持的语言回落英文。永不为 null，保证文案与门同时出现。
 */
export function getBootstrapLoadingText(language?: string | null): string {
    const normalized = normalizeSupportedLanguage(language);
    return BOOTSTRAP_LOADING_TEXTS[normalized ?? 'en'];
}
